const images = require('./Images') ;

export const fonts = {
    Roboto: {
        normal: 'node_modules/roboto-font/fonts/Roboto/roboto-regular-webfont.ttf',
        bold: 'node_modules/roboto-font/fonts/Roboto/roboto-bold-webfont.ttf',
        italics: 'node_modules/roboto-font/fonts/Roboto/roboto-italic-webfont.ttf',
        bolditalics: 'node_modules/roboto-font/fonts/Roboto/roboto-bolditalic-webfont.ttf'
    }
};

export const header = {
              margin: 10,
              columns: [
                    {width: 250,
                        image: images.schoolLogo,
                        width: 40
                    },
                    {
                        width: 270,
      				          fontSize: 18,
                        margin: [10, 10, 0, 0],
                        text: { text: 'Instituto Dr. Sallares', italics: true, bold: true }
                    } 
                ]
            };

export const footer = {
        margin: 10,
        columns: [
                {
                    width: 300,
                            fontSize: 8,
                    margin: [10, 5, 0, 0],
                    text: { text: 'España 2912, Florencio Varela (1888) - Tel. 4255-0570 \n Email: info@institutodrsallares.com.ar',
                            }
                },
                // {
                //     image: footerImage.footerImage,
                //     width: 250
                // }
            ]
        };
            
        // {
        //     style: 'tableExample',
        //     table: {
        //         body: calif
        //     }
        // })

export const signatures = {
    table: {
        widths: [ '*', 10, '*', 10, '*' ],
        body: [
            [
                {text:'', border: [false, true,false, false ]  },
                {text:'', border: [false,true]  },
                {text:'', border: [false, true,false, false ]  },
                {text:'', border: [false  ]  },
                {text:'', border: [false, true,false, false ]  }
            ],
            [
                {text:'Director del establecimiento', border: [false ] , alignment: 'center'   },
                {text:'', border: [false]  },
                {text:'Sello del Establecimiento', border: [false ], alignment: 'center'   },
                {text:'', border: [false]  },
                {text:'Inspector del Area',	border: [false ] , alignment: 'center' }
            ],
        ]
    },
    pageBreak: 'after'

};
export const styles =
        {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            // tableExample: {
            //     margin: [0, 5, 0, 15]
            // },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black'
            },
            tableBody: {
                fontSize: 8 
            },
            tableHeader2: {
                bold: true,
                fontSize: 10,
                color: 'white',
                background: '#f0f0f0'
            },
        }  ;